import {
  cn,
  twVariants
} from "./chunk-LJ5F4WFH.js";

// src/Heading/Heading.tsx
import * as React from "react";
var headingStyles = twVariants({
  base: "",
  variants: {
    variant: {
      "title-1": "font-title text-title-1 font-bold",
      "title-2": "font-title text-title-2 font-bold",
      "title-3": "font-title text-title-3 font-bold",
      "subtitle-1": "font-body text-subtitle-1 font-semibold",
      "subtitle-2": "font-body text-subtitle-2 font-semibold",
      "subtitle-3": "font-body text-subtitle-3 font-semibold"
    }
  },
  defaultVariants: {
    variant: "title-1"
  }
});
var Heading = React.forwardRef(
  ({ className, variant = "title-1", as, ...props }, ref) => {
    const Comp = as;
    return /* @__PURE__ */ React.createElement(
      Comp,
      {
        className: cn(headingStyles({ variant }), className),
        ref,
        ...props
      }
    );
  }
);
Heading.displayName = "Heading";

export {
  headingStyles,
  Heading
};
//# sourceMappingURL=chunk-YTRDWPHI.js.map